export enum SolicitationType {
  CMAJ = "CMAJ",
  CADH = "CADH",
  INDIV = "INDIVIDUAL_FORM",
  DEFAULT = "DEFAULT",
}

export function normalizeSolicitationType(raw: string | undefined | null): SolicitationType {
  if (!raw) {
    return SolicitationType.DEFAULT
  }

  const trimmed = raw.trim()

  if (Object.values(SolicitationType).includes(trimmed as SolicitationType)) {
    return trimmed as SolicitationType
  }

  if (trimmed.toUpperCase() === "INDIVIDUAL_FORM" || trimmed.toUpperCase() === "INDIV") {
    return SolicitationType.INDIV
  }

  return SolicitationType.DEFAULT
}

export function isCmajSolicitationType(type: SolicitationType | string): boolean {
  const normalized = typeof type === "string" ? normalizeSolicitationType(type) : type

  return normalized === SolicitationType.CMAJ || normalized === SolicitationType.INDIV
}

export enum SolicitationAspect {
  BUSINESS = "business",
  WINTER = "winter",
  SUMMER = "summer",
}

export function isSolicitationAspect(value: unknown): value is SolicitationAspect {
  return Object.values(SolicitationAspect).includes(value as SolicitationAspect)
}

export enum SolicitationState {
  SENT = "SENT", // mail parti au pro depuis l'OT (le pro l'a reçu)
  ANSWERED = "ANSWERED", // répondu
  SENT_APIDAE = "SENT_APIDAE", // donnée envoyée apidae (validé par l'OT)
  DRAFT = "DRAFT", // brouillon
  TREATED = "TREATED", // vu par l'OT
  SAVING = "SAVING", // en cours d'enregistrement -> bloquer l'accès aux actions
  SAVING_DRAFT = "SAVING_DRAFT", // status temporaire durant le temps d'enregistrement, même action que SAVING
}

export function isDraftSolicitationState(state: SolicitationState): boolean {
  return state === SolicitationState.DRAFT || state === SolicitationState.SAVING_DRAFT
}

export function isSavingDraftSolicitationState(state: SolicitationState): boolean {
  return state === SolicitationState.SAVING_DRAFT
}

export function isSavingSolicitationState(state: SolicitationState): boolean {
  return state === SolicitationState.SAVING || state === SolicitationState.SAVING_DRAFT
}
